import { useEffect, useMemo, useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import { useIsPortrait } from '../../../../util/breakpoints'
import { isInScrollRange } from '../../../../util/scrollPercentage'
import { Poster, ScrollVideoProps, VideoContainer } from './ScrollVideo'
import { getFirstFrameUrl, getLastFrameUrl, getMiddleFrameUrl } from '../../../../util/path'

export default function ScrollVideoBySeek(props: ScrollVideoProps) {
  const videoRef = useRef<ReactPlayer>(null)
  const [videoIsReady, setVideoIsReady] = useState<boolean>(false)
  const [renderVideoPlayer, setRenderVideoPlayer] = useState<boolean>(false)
  const isPortrait = useIsPortrait()

  const videoUrl = isPortrait ? props.videoPortrait : props.videoLandscape

  useEffect(() => {
    // only render video player on client-side
    setRenderVideoPlayer(true)
  }, [])

  // Update video time when scroll percentage changes
  useEffect(() => {
    if (
      props.isActive &&
      isInScrollRange(props.scrollPercentage) &&
      videoIsReady
    ) {
      videoRef.current?.seekTo(props.scrollPercentage, 'fraction')
    }
  }, [props.isActive, props.scrollPercentage, videoIsReady])

  const memoizedPlayer = useMemo(() => {
    return (
      <ReactPlayer
        className="video-player"
        onReady={() => setVideoIsReady(true)}
        ref={videoRef}
        url={videoUrl ?? ''}
        width="100%"
        height="100%"
        style={{ opacity: videoIsReady ? 1 : 0 }}
        playsinline
        muted
        aria-label={props.alt}
        config={{
          file: {
            attributes: {
              preload: 'auto',
            },
          },
        }}
      />
    )
  }, [videoRef, videoUrl, videoIsReady, props.alt])

  return (
    <VideoContainer>
      {renderVideoPlayer && memoizedPlayer}

      <Poster
        posterIsVisible={props.scrollPercentage <= 1}
        posterUrl={getLastFrameUrl(videoUrl)}
      />
      <Poster
        posterIsVisible={props.scrollPercentage <= 0.66}
        posterUrl={getMiddleFrameUrl(videoUrl)}
      />
      <Poster
        posterIsVisible={props.scrollPercentage <= 0.33}
        posterUrl={getFirstFrameUrl(videoUrl)}
      />
    </VideoContainer>
  )
}
